import { type JSX } from 'react';
import { useTranslation } from 'react-i18next';

import { HelpContent } from '@/components/help/help-content';

/**
 * /help — full help center page. Sidebar of categories + search-able
 * list. Same content surface as the topbar "?" drawer; this just
 * gives it room to breathe + browse by category.
 */
export default function HelpPage(): JSX.Element {
  const { t } = useTranslation('default');

  return (
    <div className="px-8 py-8 max-w-[1100px] mx-auto">
      <header className="mb-6">
        <h1 className="display text-[28px] font-semibold tracking-tight text-text leading-tight m-0">
          {t('help_title')}
        </h1>
        <p className="text-[13px] text-text-3 mt-1.5">
          {t('help_subtitle')}
        </p>
      </header>

      <HelpContent layout="page" />
    </div>
  );
}
